import { handleActions } from "redux-actions";
import { getMDLDataDone } from "../actions/actions";

export default handleActions(
  {
    [getMDLDataDone]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
